'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/chart.js/src/charts/Chart.Doughnut.js
// module id = 1229
// module chunks = 1